module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C221"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("ABBREVIATIONS AND MATTERS OF CITATION")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('table', [_c('tbody', [_c('tr', {
    staticClass: "Row_Style4"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Acad., Acad. Pr")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("Academics")]), _vm._v(" and "), _c('em', [_vm._v("Prior Academics")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Ad Brut")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("Epistulae ad M. Brutum")]), _vm._v(" (Letters to Brutus)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("AM")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Sextus Empiricus, "), _c('em', [_vm._v("Adversus mathematicos")]), _vm._v(" (Against the Professors)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Att")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("Letters to Atticus")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("D.L.")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Diogenes Laertius, "), _c('em', [_vm._v("Lives and Opinions of Eminent Philosophers")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("EK")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("Posidonius: The Fragments")]), _vm._v(", ed. Edelstein and Kidd 1989")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Ep")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Seneca, "), _c('em', [_vm._v("Epistulae morales ad Lucilium")]), _vm._v(" (Moral Epistles to Lucilius)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Ep. Hdt")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Epicurus, "), _c('em', [_vm._v("Epistle to Herodotus")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Ep. Men")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Epicurus, "), _c('em', [_vm._v("Epistle to Menoikeus")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Fam")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("Epistulae ad familiares")]), _vm._v(" (Letters to Friends)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("KD")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Epicurus, "), _c('em', [_vm._v("Kuriai Doxai")]), _vm._v(" (Principal Doctrines)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("LSJ")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("Greek–English Lexicon")]), _vm._v(", ed. H. G. Liddell, R. Scott, and H. S. Jones (Oxford, 1968)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("ND")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("De natura deorum")]), _vm._v(" (On the Nature of the Gods)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("NE")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Aristotle, "), _c('em', [_vm._v("Nicomachean Ethics")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Off")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("De officiis")]), _vm._v(" (On Appropriate Actions)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("OLD")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("Oxford Latin Dictionary")]), _vm._v(", ed. P.G.W. Glare (Oxford, 1982)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("PHP")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("Galen: On the Doctrines of Hippocrates and Plato")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("QFr")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("Epistulae ad Quintum fratrem")]), _vm._v(" (Letters to Quintus)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Rhet")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Aristotle, "), _c('em', [_vm._v("Rhetoric")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("Stob., "), _c('em', [_vm._v("Ecl")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Stobaeus, "), _c('em', [_vm._v("Eclogae")]), _vm._v(" (Anthology)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("SVF")])])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("Stoicorum veterum fragmenta")]), _vm._v(", ed. von Arnim 1921")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style1"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Tusc")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Cicero, "), _c('em', [_vm._v("Tusculan Disputations")]), _vm._v(", books 1, 2, and 5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_vm._v("Cross-references to the translation are to book and chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Translations are my own unless otherwise noted. Where the commentary makes assertions as to the derivation or meaning of specific words and phrases, I have relied on the relevant entries in the standard lexica as noted above, including a citation only if needed to pinpoint a section of a long entry.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Dates for persons and events are given in accordance with the relevant articles in the "), _c('em', [_vm._v("Oxford Classical Dictionary")]), _vm._v(" (ed. S. Hornblower and A. Spawforth, Oxford, 1996). All dates in this volume are B.C.E. unless otherwise indicated.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("The bibliographical notes provided with each section are meant to direct the reader to important recent treatments of specific topics, with emphasis on works in English, and to indicate which modern treatments have most influenced my reading of the evidence. They are not by any means comprehensive. Fuller bibliographical resources for matters treated in this volume can be found especially in Everson 1998, Barnes and Griffin 1997, Griffin and Barnes 1989, and Long and Sedley 1987.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d708851","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_ABBREVIATIONS_AND_MATTERS_OF_CIT.vue
// module id = 69
// module chunks = 0